/**
 * When editing an entity that has `account_id`, default select `queryParams.account_id`
 * to that entity's account so options come from B when editing a shared B entity.
 * Explicit `fieldProps.queryParams` still win (spread last). Creates typically omit `object`.
 */
export function mergeEntityScopedFieldProps(object: object | undefined, fieldProps?: Record<string, unknown> | null) {
    const accountId =
        object && 'account_id' in object && typeof (object as { account_id?: unknown }).account_id === 'string'
            ? (object as { account_id: string }).account_id
            : undefined;

    if (!accountId && !fieldProps) {
        return fieldProps;
    }

    const rawQueryParams = fieldProps?.['queryParams'];
    const existingQueryParams = rawQueryParams && typeof rawQueryParams === 'object' ? (rawQueryParams as Record<string, unknown>) : undefined;

    return {
        ...fieldProps,
        queryParams: {
            ...(accountId ? { account_id: accountId } : {}),
            ...existingQueryParams
        }
    };
}
